import { FormattedMessage } from 'react-intl';
import React, { useEffect } from 'react';
import { StringConstantsMixin } from 'react_components/mixins/shared/string_constants_mixin';
import AnchorButton from 'components/AnchorButton';
import CustomIntlProvider from 'components/CustomIntlProvider';
import { logExploreWithProButtonClicked, logProWelcomePageViewed } from '@alltrails/analytics/amplitudeFunctions';
import * as styles from './styles.module.scss';

const {
  FOR_THE_BEST_EXPERIENCE,
  START_EXPLORING_WITH_PRO,
  YOU_RE_AN_OFFICIAL_PRO_SUBSCRIBER,
  WELCOME_TO_OUR_COMMUNITY_OF_OUTDOOR_ENTHUSIASTS_JUST_LIKE_YOU
} = StringConstantsMixin.strings;

function ProWelcome() {
  useEffect(() => {
    logProWelcomePageViewed();
  }, []);

  // could be a shared function
  const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

  return (
    <CustomIntlProvider>
      <div className={styles.proWelcome}>
        <section>
          <div className={styles.welcomeText}>
            <h1 className={styles.heading}>
              <FormattedMessage defaultMessage="Welcome to {pro}." values={{ pro: <span className={styles.welcomeProBadge} /> }} />
            </h1>
            <p className={styles.welcome}>
              {YOU_RE_AN_OFFICIAL_PRO_SUBSCRIBER}
              <br />
              {WELCOME_TO_OUR_COMMUNITY_OF_OUTDOOR_ENTHUSIASTS_JUST_LIKE_YOU}
            </p>
            {isMobile ? (
              <p className={styles.mobile}>{FOR_THE_BEST_EXPERIENCE}</p>
            ) : (
              <AnchorButton href="/explore?ref=pro-welcome" onClick={logExploreWithProButtonClicked}>
                {START_EXPLORING_WITH_PRO}
              </AnchorButton>
            )}
          </div>
          <div className={styles.topImage} />
        </section>
      </div>
    </CustomIntlProvider>
  );
}

export default ProWelcome;
